import React from "react";
import { getAvatarColor, getInitials } from "../Meetings/Meetings.utils";
import {
  formatTime,
  resolveAuthor,
  resolveMentions,
} from "./Conversation.utils";
import LoadingComponent from "../../components/common/LoadingComponent";
import { useConversationContext } from "./ConversationContext";
import { Icons } from "../../constants/icon-library";

function ThreadReplyItem({ thread, threadId, replyProps, showActions = true }) {
  const { authorMap, meta } = useConversationContext();
  const { isCommentIntegration } = meta;
  const {
    replyOpen,
    replyDraft,
    isSendingReply,
    onToggleReply,
    onReplyChange,
    onSendReply,
  } = replyProps;

  const threadName = resolveAuthor(
    thread.author,
    authorMap
  );
  const showViewLink = isCommentIntegration && !!thread.link;

  return (
    <div className="w-100">
      <div className="d-flex align-items-start gap-2 w-100">
        <div
          className="rounded-circle d-flex align-items-center justify-content-center fw-bold flex-shrink-0 text-white conv-avatar-xs"
          style={{ backgroundColor: getAvatarColor(threadName) }}
        >
          {getInitials(threadName)}
        </div>

        <div className="position-relative flex-grow-1 min-w-0">
          <div className="bg-theme shadow-sm conv-bubble-sm">
            <div className="d-flex align-items-baseline justify-content-between gap-2 mb-1">
              <span
                className="fw-semibold conv-author-name-sm"
                style={{ color: getAvatarColor(threadName) }}
              >
                {threadName}
              </span>
              {thread.sentAt && (
                <small className="text-body-secondary conv-time-xs">
                  {formatTime(thread.sentAt)}
                </small>
              )}
            </div>
            <div className="text-body conv-bubble-text-sm">
              {resolveMentions(thread.text, authorMap)}
            </div>
          </div>

          {(showActions || showViewLink) && (
            <div className="conv-thread-actions d-flex gap-1">
              {showViewLink && (
                <a
                  href={thread.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn p-0 bg-body shadow-sm border-0 conv-action-btn-xs"
                  title="View on platform"
                >
                  <i className={`wb ${Icons("view")} me-1`} />
                </a>
              )}
              {showActions && (
                <button
                  type="button"
                  className="btn p-0 bg-body shadow-sm border-0 conv-action-btn-xs"
                  title="Reply"
                  onClick={() => onToggleReply(threadId)}
                >
                  <i className="bi bi-reply text-body-secondary" />
                </button>
              )}
            </div>
          )}
        </div>
      </div>

      {replyOpen && (
        <div className="ms-5 mt-2 d-flex gap-2">
          <input
            type="text"
            className="form-control form-control-sm bg-body-secondary border-0 rounded-pill px-3 conv-reply-input-sm"
            placeholder={`Reply to ${threadName}`}
            value={replyDraft || ""}
            onChange={(e) => onReplyChange(threadId, e.target.value)}
            disabled={isSendingReply}
            autoFocus
            onKeyDown={(e) => {
              if (e.key === "Enter" && !e.shiftKey) {
                e.preventDefault();
                onSendReply(thread, threadId);
              }
            }}
          />
          <button
            type="button"
            className="btn btn-sm btn-primary rounded-pill px-3 flex-shrink-0 d-flex align-items-center justify-content-center conv-reply-send-btn"
            onClick={() => onSendReply(thread, threadId)}
            disabled={!replyDraft?.trim() || isSendingReply}
          >
            {isSendingReply ? (
              <span className="conv-spinner-wrap">
                <LoadingComponent
                  loading={true}
                  size={6}
                  wrapperStyle={{
                    padding: 0,
                    lineHeight: 0,
                    display: "flex",
                    flexDirection: "row",
                    whiteSpace: "nowrap",
                  }}
                />
              </span>
            ) : (
              <i className="bi bi-send-fill" />
            )}
          </button>
        </div>
      )}
    </div>
  );
}

export default ThreadReplyItem;